import type { FaireProductEntity } from "../../entity_types/product";

export const p_guzrc3d4hd: FaireProductEntity = {
  token: "p_guzrc3d4hd",
  type: "product",
  name: "I Do All The Pretty Girls Spray Tans Embroidered Five Panel Twill Cap",
  brandToken: "b_8wgak58597",
  brandName: "Wholesale Accessory Market",
  imageUrl:
    "https://cdn.faire.com/fastly/90e88f3ec4ee59b26cd3586a42e34aa50f0967af2b0097fd26e96ec292bb2108.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/47432b169b5cca73776ba4e6aa0f905552901e67306e18c47900c3710f27860b.jpeg",
    "https://cdn.faire.com/fastly/fb3a6cf57d089d2ff82c6308d2058d862b9c7f3883230c1833586d15259097bc.jpeg",
    "https://cdn.faire.com/fastly/e4cc2b02a941e6b1aeeab1e7a14b1ebac2ff4316eed3b5e9023702cb97638f47.jpeg",
    "https://cdn.faire.com/fastly/df07ef625ce29f315197c6b3efb1b6793288cba6dfd99974c48216a7a98ff4c7.jpeg",
    "https://cdn.faire.com/fastly/76f3ea47ea3c945fb166ce2976dda6db71db7d93d18352b539be479253a05711.jpeg",
    "https://cdn.faire.com/fastly/1ece8aa7e4556869e771d67e657d39f84dd0fa8554e56eef1a4b5673fda92e43.jpeg",
  ],
  priceDollars: 15,
  description:
    "\nCover up your bad hair day with this fun graphic cap!\n\nHats are made to order and do require 3-4 business days of processing time.\nEmbroidered text color will match the bill of the cap.\n\n\n * 80% Polyester/20% Cotton Twill \n * 100% Polyester Mesh Back Panels \n * Structured \n * 5 Panel \n * Mid-Profile \n * Pre-Curved Visor with Braided Detailing \n * Button Top \n * Snapback Closure \n * Adjustable, One Size Fits Most ",
  tags: [],
  msrpDollars: 30,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:51.387Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
